import { useEffect } from "react";

const DEFAULTS = {
  title: "1o1sound — Sound that moves you",
  description: "Stream, discover, and curate music. 2 months Premium free, then $10/month.",
  image: "https://customer-assets.emergentagent.com/job_audio-flow-133/artifacts/e1fop4m5_IMG_7311.png",
};

const setMeta = (selector, attr, value) => {
  let el = document.head.querySelector(selector);
  if (!el) {
    el = document.createElement("meta");
    const [a, v] = selector.replace(/^meta\[|\]$/g, "").split("=");
    el.setAttribute(a, v.replace(/['"]/g, ""));
    document.head.appendChild(el);
  }
  el.setAttribute(attr, value);
};

/**
 * Dynamically update document title + OG/Twitter meta tags.
 * Most modern crawlers (Slack, Twitter, Discord, Telegram, iMessage iOS17+)
 * execute JS so this works for share previews.
 */
export const useMeta = ({ title, description, image, url } = {}) => {
  useEffect(() => {
    const t = title || DEFAULTS.title;
    const d = description || DEFAULTS.description;
    const i = image || DEFAULTS.image;
    const u = url || window.location.href;

    document.title = t;
    setMeta('meta[name="description"]', "content", d);
    setMeta('meta[property="og:title"]', "content", t);
    setMeta('meta[property="og:description"]', "content", d);
    setMeta('meta[property="og:image"]', "content", i);
    setMeta('meta[property="og:url"]', "content", u);
    setMeta('meta[property="og:type"]', "content", "music.playlist");
    setMeta('meta[name="twitter:card"]', "content", "summary_large_image");
    setMeta('meta[name="twitter:title"]', "content", t);
    setMeta('meta[name="twitter:description"]', "content", d);
    setMeta('meta[name="twitter:image"]', "content", i);

    return () => {
      // restore defaults on unmount so SPA navigation feels right
      document.title = DEFAULTS.title;
    };
  }, [title, description, image, url]);
};
